export default "__VITE_ASSET__4efa2203__"